<template>
    <svg  class="icon-sort" viewBox="0 0 13 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Dashboard-DNA" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="AI-Profiler---Sort" transform="translate(-339, -473)" fill="#FFFFFF" fill-rule="nonzero">
                <g id="Group-15" transform="translate(339, 470)">
                    <g id="swap_vert_24dp_5F6368_FILL1_wght400_GRAD0_opsz24" transform="translate(0, 3)">
                        <path d="M3.2,8.8 L3.2,3.06 L1.14,5.12 L0,4 L4,0 L8,4 L6.86,5.12 L4.8,3.06 L4.8,8.8 L3.2,8.8 Z M8.8,16 L4.8,12 L5.94,10.88 L8,12.94 L8,7.2 L9.6,7.2 L9.6,12.94 L11.66,10.88 L12.8,12 L8.8,16 Z" id="Shape"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<style scoped>
    .icon-sort {
        width: 13px;
        height: 16px;
    }
    
    svg:hover path {
        fill: #7db2ae;
    }
</style>